module.exports = __webpack_public_path__ + "static/media/bell.c16fd631.svg";